import { QueryClient } from "@tanstack/react-query";

const AUTH_KEY = "ilovemacumba:auth:currentUser";
const TERREIRO_CURRENT_KEY = "ilovemacumba:terreiro:current";

export function hydratePersistedCache(qc: QueryClient) {
  try {
    const auth = localStorage.getItem(AUTH_KEY);
    if (auth) {
      try {
        const parsed = JSON.parse(auth);
        qc.setQueryData(["auth", "currentUser"], parsed);
      } catch {
        // Ignore JSON parse errors
        console.error("Failed to parse auth data from localStorage");
      }
    }

    const terreiro = localStorage.getItem(TERREIRO_CURRENT_KEY);
    if (terreiro) {
      try {
        const parsed = JSON.parse(terreiro);
        qc.setQueryData(["terreiro", "current"], parsed);
        const id = parsed?.id;
        if (id) {
          qc.setQueryData(["terreiro", id], parsed);
        }
      } catch {
        // Ignore JSON parse errors
        console.error("Failed to parse terreiro data from localStorage");
      }
    }
  } catch {
    // never fail app startup because of persistence
  }
}
export default hydratePersistedCache;
